import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'ui/atoms'
import SelectButton from 'ui/components/SelectButton/SelectButton'

type CreateSettingButtonProps = {
  allowTimeSeries: boolean
  disabled: boolean
  onCreate: (isTimeSeries: boolean) => void
}

export function CreateSettingButton({ allowTimeSeries, disabled, onCreate }: CreateSettingButtonProps): ReactNode {
  const { t } = useTranslation()

  if (!allowTimeSeries) {
    return (
      <Button primary onClick={() => onCreate(false)} disabled={disabled}>
        {t('Create new setting')}
      </Button>
    )
  }

  return (
    <SelectButton
      icon="fal fa-plus"
      primary
      disabled={disabled}
      disabledTooltip={t('Unfortunately, you do not have permission to create settings on this user/facility')}
      menuItems={[
        { label: t('Setting'), onClick: () => onCreate(false) },
        { label: t('Time series setting'), onClick: () => onCreate(true) },
      ]}
    >
      {t('Create new setting')}
    </SelectButton>
  )
}
